export const ROLE_OPTIONS = [
  { value: "owner", label: "Proprietário", help: "Controle completo do painel, incluindo usuários e acessos." },
  { value: "analyst", label: "Analista", help: "Dashboard, gráficos, rankings, filtros, exportações e monitor de links." },
  { value: "viewer", label: "Somente leitura", help: "Visualiza e exporta os dados permitidos, sem operações." },
];
export const ROLE_LABEL = Object.fromEntries(ROLE_OPTIONS.map((r) => [r.value, r.label]));
export const ROLE_TONE = { owner: "accent", analyst: "ok", viewer: "muted" };
export const STATUS = {
  active: ["Ativa", "ok"],
  invited: ["Convite pendente", "warn"],
  disabled: ["Desativada", "bad"],
};
export const AUDIT_LABELS = {
  login: "Login",
  login_failed: "Login com senha incorreta",
  login_blocked_inactive: "Login bloqueado (conta inativa)",
  user_created: "Conta criada",
  invite_regenerated: "Novo link de convite",
  invite_accepted: "Convite aceito",
  role_changed: "Nível de acesso alterado",
  user_renamed: "Nome alterado",
  user_disabled: "Conta desativada",
  user_enabled: "Conta reativada",
  sessions_revoked: "Sessões revogadas",
  user_deleted: "Conta excluída",
};
